import styled from 'styled-components';

export const HelpText = styled.p`
  margin-bottom: ${({ theme }) => theme.pxToRem(20)};
  color: ${({ theme }) => theme.colours.charcoalDust};
`;
